import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { isEmpty, map } from 'lodash';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Collapse } from 'antd';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';

import './sidebar.scss';

type NavigationItem = {
  label: string;
  href?: string;
  isActive?: boolean;
}

export type SidebarNavigationItem = NavigationItem & {
  icon?: React.ReactNode;
  children?: Array<NavigationItem & { children?: NavigationItem[] }>;
}

interface ChildSidebarProps {
  elKey: number | string;
  navigationItem: SidebarNavigationItem;
  activeKey?: number | number[] | string | string[];
  onChange?: (key: number | number[] | string | string[]) => void;
}

const ChildSidebar = ({ elKey, navigationItem, activeKey, onChange }: ChildSidebarProps) => {
  return (
    <React.Fragment>
      {isEmpty(navigationItem.children) &&
      <React.Fragment>
        <a href={navigationItem.href}>
          <span className="label">{navigationItem.label}</span>
        </a>
      </React.Fragment>
      }

      {!isEmpty(navigationItem.children) &&
      <Collapse
        ghost={true}
        expandIconPosition="right"
        activeKey={activeKey}
        onChange={onChange}
      >
        <Collapse.Panel
          key={elKey}
          header={
            <React.Fragment>
              <span className="label label--no-icon">{navigationItem.label}</span>
            </React.Fragment>
          }
        >
          <ul>
            {map(navigationItem.children, (subItem: NavigationItem, subItemKey: number | string) => {
              if (subItem.isActive) {
                return (
                  <li key={`${elKey}.${subItemKey}`}>
                    <a href={subItem.href}>
                      <span className="label sub-label">{subItem.label}</span>
                    </a>
                  </li>
                )
              }
            })}
          </ul>
        </Collapse.Panel>
      </Collapse>
      }
    </React.Fragment>
  )
}

export interface SidebarProps {
  navigation: SidebarNavigationItem[];
  isOpen?: boolean;
  onToggle?: (value: boolean) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
                                                  navigation,
                                                  isOpen,
                                                  onToggle,
                                                }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<number | number[] | string | string[]>(0);

  const handleToggle = () => {
    // if (!isCollapsed) { setActiveKey(0) }
    // setIsCollapsed(!isCollapsed);
    // if (onToggle) onToggle(!isCollapsed);
  }

  const handleClick = (key: number | number[] | string | string[] ) => {
    if (isCollapsed) {
      setIsCollapsed(false);
      setActiveKey(key);
    }
  }

  const handleChange = (key: number | number[] | string | string[] ) => {
    setActiveKey(key)
  }

  return (
    <div
      className={classNames('sidebar', {
        'collapsed': isCollapsed,
        'sidebar--open': isOpen
      })}
    >
      <div className="sidebar-inner">
        <Scrollbars autoHide universal>
          <ul>
            {navigation.map((item, itemKey) => {
              if (item.isActive) {
                return (
                  <React.Fragment key={itemKey}>
                    {isEmpty(item.children) &&
                    <li>
                      <a href={item.href}>
                        <span className="icon">{item.icon} </span>
                        <span className="label">{item.label}</span>
                      </a>
                    </li>
                    }

                    {!isEmpty(item.children) &&
                    <React.Fragment>
                      <li onClick={() => handleClick(itemKey)}>
                        <Collapse
                          ghost={true}
                          expandIconPosition="right"
                          activeKey={activeKey}
                          onChange={handleChange}
                        >
                          <Collapse.Panel
                            key={itemKey}
                            header={
                              <React.Fragment>
                                <span className="icon">{item.icon}</span>
                                <span className="label">{item.label}</span>
                              </React.Fragment>
                            }
                          >
                            <ul>
                              {map(item.children, (subItem, subItemKey) => {
                                if (subItem.isActive) {
                                  return (
                                    <li key={`${itemKey}.${subItemKey}`}>
                                      <ChildSidebar
                                        elKey={`${itemKey}.${subItemKey}`}
                                        navigationItem={subItem}
                                        activeKey={activeKey}
                                        onChange={handleChange}
                                      />
                                    </li>
                                  )
                                }
                              })}
                            </ul>
                          </Collapse.Panel>
                        </Collapse>
                      </li>
                    </React.Fragment>
                    }
                  </React.Fragment>
                )
              }
            })}
          </ul>
        </Scrollbars>
      </div>

      <div className="sidebar--footer" onClick={handleToggle}>
        {isCollapsed &&
        <DoubleRightOutlined />
        }

        {!isCollapsed &&
        <DoubleLeftOutlined />
        }
      </div>
    </div>
  )
}
